<template>
  <div id="report-details-screen">
    <div class="content" v-if="report">
      <div class="row header-row">
        <div class="col-6">
          <div class="title">Detailed Report</div>
          <div class="interval">{{ report.month + 1 }} / {{ report.year }}</div>
        </div>
        <div class="col-6 text-right">
          <img class="logo" src="/static/images/logo_full.svg" alt="" />
        </div>
      </div>
      <div class="row header-row">
        <div class="col-4">
          <div class="header-label">ALL GIVEN FEEDBACK</div>
          <div class="header-value">
            {{ report.summary.pointCounter }}
          </div>
        </div>
        <div class="col-4">
          <div class="header-label">ALL GIVEN POINTS</div>
          <div class="header-value">
            {{ report.summary.pointSummary }}
          </div>
        </div>
        <div class="col-4">
          <div class="header-label">POINTS RATIO (used / available)</div>
          <div class="header-value">
            {{
              report.summary.availabledPoints - report.summary.remainedPoints
            }}
            /
            {{ report.summary.availabledPoints }} 
          </div>
        </div>
      </div>
      <div class="row header-row">
        <div class="col-4">
          <div class="header-label">NUMBER OF USERS</div>
          <div class="header-value">
            {{ report.summary.userCount }}
          </div>
        </div>
        <div class="col-4">
          <div class="header-label">USER WITHOUT SENT FEEDBACK</div>
          <div class="header-value">
            {{ report.summary.userWithoutSentFeedback }}
          </div>
        </div>
        <div class="col-4">
          <div class="header-label">USER WITHOUT RECEIVED FEEDBACK</div>
          <div class="header-value">
            {{ report.summary.userWithoutReceivedFeedback }}
          </div>
        </div>
      </div>
      <div class="page-break"></div>
      <div class="row table-row">
        <div class="col-12">
          <div class="section-title">
            <span>USERS</span>
          </div>
        </div>
        <table class="data-table">
          <thead>
            <td>#</td>
            <td>Name</td>
            <td>Received <br />feedback</td>
            <td>Received <br />points</td>
            <td>Given <br />feedback</td>
            <td>Given <br />points</td>
            <td>Started <br />feedback</td>
            <td>Joined <br />feedback</td>
          </thead>
          <tbody>
            <tr v-for="(userData, index) of users" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ userData.firstName }} {{ userData.lastName }}</td>
              <td>
                {{ userData.receivedFeedbackCounter }}
              </td>
              <td>
                {{ userData.receivedPointAmount }}
              </td>
              <td>
                {{ userData.sentFeedbackCounter }}
              </td>
              <td>
                {{ userData.sentPointAmount }}
              </td>
              <td>
                {{ userData.startedFeedback }}
              </td>
              <td>
                {{ userData.joinedFeedback }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page-break"></div>
      <div class="row table-row">
        <div class="col-12">
          <div class="section-title">
            <span>Categories</span>
          </div>
        </div>
        <table class="data-table">
          <thead>
            <td>Name</td>
            <td>Points</td>
          </thead>
          <tbody>
            <tr
              v-for="(categoryData, index) of report.categoriesData"
              :key="index"
            >
              <td>{{ categoryData.name }}</td>
              <td>{{ categoryData.amount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page-break"></div>
      <div class="row table-row">
        <div class="col-12">
          <div class="section-title">
            <span>Top reasons</span>
          </div>
        </div>
        <table class="data-table">
          <thead>
            <td>Reason</td>
            <td>Feedback counter</td>
            <td>Points summary</td>
          </thead>
          <tbody>
            <tr
              v-for="(reason, index) of report.summary.topReasons"
              :key="index"
            >
              <td>{{ reason._id }}</td>
              <td>{{ reason.count }}</td>
              <td>{{ reason.totalAmount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page-break"></div>
      <div class="row table-row">
        <div class="col-12">
          <div class="section-title">
            <span>Feedback</span>
          </div>
        </div>
        <table class="data-table">
          <thead>
            <td>Receiver user</td>
            <td>Sender user</td>
            <td>Reason</td>
            <td>Points</td>
            <td>Category</td>
          </thead>
          <tbody>
            <tr v-for="(feedbackData, index) of feedback" :key="index">
              <td>{{ feedbackData.receiverUserName }}</td>
              <td>{{ feedbackData.senderUserName }}</td>
              <td>{{ feedbackData.reason }}</td>
              <td>{{ feedbackData.amount }}</td>
              <td>{{ getCategory(feedbackData.category) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReportsScreen',
  components: {},
  data: () => ({
    report: undefined,
  }),
  async created() {
    this.report = await this.fetchReport({
      companyId: this.$route.params.companyId,
      id: this.$route.params.id,
    });
    setTimeout(() => {
      window.print();
    }, 1000);
  },
  computed: {
    users() {
      const users = [...this.report.usersData];
      users.sort((a, b) => b.receivedPointAmount - a.receivedPointAmount);
      return users;
    },
    feedback() {
      const feedback = [...this.report.feedbackData];
      feedback.sort((a, b) => b.amount - a.amount);
      return feedback;
    },
  },
  methods: {
    ...mapActions({
      fetchReport: 'reports/get',
    }),
    getCategory(categoryId) {
      return this.report.categoriesData.find((x) => x.index === categoryId).name;
    },
  },
};
</script>

<style lang="scss" scoped>
#report-details-screen {
  width: 100vw;
  padding-bottom: 100px;
  .content {
    margin: 0 auto;
    max-width: 95%;
    .header-row {
      padding: 50px 0;
      border-bottom: 2px solid #ddd;
      .title {
        font-size: 30px;
        text-align: left;
      }
      .logo {
        max-height: 30px;
      }
      .interval {
        text-align: left;
        color: #aaa;
      }
      .header-label {
        color: #999;
        font-size: 12px;
        height: 40px;
      }
      .header-value {
        font-size: 30px;
      }
    }
    .section-title {
      font-size: 25px;
      margin: 20px 0;
      span {
        padding: 5px;
        background-color: #eee;
      }
    }
    .table-row {
      margin-top: 70px;
    }
    .data-table {
      width: 100%;
      text-align: left;
      page-break-after: always;
      thead {
        border-bottom: 1px solid #ddd;
      }
      td {
        padding: 5px;
      }
      tr:nth-child(even) {
        background: #eee;
      }
    }
  }
}
</style>
<style>
@media print {
  .pagebreak {
    clear: both;
    display: block;
    page-break-after: always;
    position: relative;
  }
}
</style>
